(function () {
  var PAPAPARSE_SRC = '//cdn.shopify.com/s/files/1/0068/1836/5529/t/4/assets/papaparse.js?v=14160904763589616364';

  function loadPapaParse(cb) {
    if (window.Papa) {
      cb();
      return;
    }
    var existing = document.querySelector('script[data-tb-papaparse]');
    if (existing) {
      existing.addEventListener('load', cb);
      return;
    }
    var s = document.createElement('script');
    s.src = PAPAPARSE_SRC;
    s.async = true;
    s.setAttribute('data-tb-papaparse', '1');
    s.onload = cb;
    document.head.appendChild(s);
  }

  function fadeShow(el) {
    if (!el) return;
    el.style.display = '';
    if (!el.style.display || el.style.display === 'none') el.style.display = 'block';
    el.style.opacity = '1';
  }
  function fadeHide(el) {
    if (!el) return;
    el.style.display = 'none';
    el.style.opacity = '0';
  }
  function showEl(el) {
    if (!el) return;
    el.style.display = '';
    if (getComputedStyle(el).display === 'none') el.style.display = 'block';
  }
  function hideEl(el) {
    if (!el) return;
    el.style.display = 'none';
  }

  // Minimal multi-element collection for the shade quiz selectors/events (vanilla DOM helper).
  function Dom(nodes) {
    this.nodes = Array.prototype.slice.call(nodes || []);
    this.length = this.nodes.length;
  }
  Dom.prototype.each = function (fn) {
    this.nodes.forEach(function (n, i) { fn.call(n, i, n); });
    return this;
  };
  Dom.prototype.on = function (evt, selOrFn, maybeFn) {
    if (typeof selOrFn === 'function') {
      this.nodes.forEach(function (n) { n.addEventListener(evt, selOrFn); });
    } else {
      var sel = selOrFn, fn = maybeFn;
      document.addEventListener(evt, function (e) {
        var t = e.target.closest(sel);
        if (!t) return;
        // only fire if match is within one of our roots OR document-level
        fn.call(t, e);
      });
    }
    return this;
  };
  Dom.prototype.click = function (fn) {
    if (!fn) {
      this.nodes.forEach(function (n) { n.click(); });
      return this;
    }
    return this.on('click', fn);
  };
  Dom.prototype.change = function () {
    this.nodes.forEach(function (n) {
      n.dispatchEvent(new Event('change', { bubbles: true }));
    });
    return this;
  };
  Dom.prototype.val = function (v) {
    if (v === undefined) {
      var n = this.nodes[0];
      return n ? n.value : undefined;
    }
    this.nodes.forEach(function (n) { n.value = v; });
    return this;
  };
  Dom.prototype.html = function (v) {
    if (v === undefined) {
      var n = this.nodes[0];
      return n ? n.innerHTML : undefined;
    }
    this.nodes.forEach(function (n) { n.innerHTML = v; });
    return this;
  };
  Dom.prototype.text = function (v) {
    if (v === undefined) {
      var n = this.nodes[0];
      return n ? (n.textContent || '') : '';
    }
    this.nodes.forEach(function (n) { n.textContent = v; });
    return this;
  };
  Dom.prototype.append = function (html) {
    this.nodes.forEach(function (n) {
      if (typeof html === 'string') n.insertAdjacentHTML('beforeend', html);
      else if (html && html.nodeType) n.appendChild(html);
    });
    return this;
  };
  Dom.prototype.empty = function () {
    this.nodes.forEach(function (n) { n.innerHTML = ''; });
    return this;
  };
  Dom.prototype.show = function () {
    this.nodes.forEach(showEl);
    return this;
  };
  Dom.prototype.hide = function () {
    this.nodes.forEach(hideEl);
    return this;
  };
  Dom.prototype.fadeIn = function () {
    this.nodes.forEach(fadeShow);
    return this;
  };
  Dom.prototype.fadeOut = function () {
    this.nodes.forEach(fadeHide);
    return this;
  };
  Dom.prototype.css = function (prop, val) {
    if (typeof prop === 'object') {
      this.nodes.forEach(function (n) {
        Object.keys(prop).forEach(function (k) { n.style[k] = prop[k]; });
      });
    } else if (val !== undefined) {
      this.nodes.forEach(function (n) { n.style[prop] = val; });
    }
    return this;
  };
  Dom.prototype.addClass = function (c) {
    this.nodes.forEach(function (n) { n.classList.add(c); });
    return this;
  };
  Dom.prototype.removeClass = function (c) {
    this.nodes.forEach(function (n) { n.classList.remove(c); });
    return this;
  };
  Dom.prototype.is = function (sel) {
    return this.nodes[0] ? this.nodes[0].matches(sel) : false;
  };
  Dom.prototype.has = function (el) {
    if (!this.nodes[0]) return new Dom([]);
    var found = this.nodes[0].contains(el && el.nodeType ? el : null);
    return found ? new Dom([el]) : new Dom([]);
  };
  Dom.prototype.delay = function (ms) {
    var self = this;
    return {
      fadeIn: function () {
        setTimeout(function () { self.fadeIn(); }, ms);
        return self;
      },
      fadeOut: function () {
        setTimeout(function () { self.fadeOut(); }, ms);
        return self;
      }
    };
  };
  Dom.prototype.remove = function () {
    this.nodes.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
    return this;
  };
  Dom.prototype.trim = function () {
    // used incorrectly in original as q('#x').val().trim() — keep no-op on Dom
    return this;
  };

  function q(sel, ctx) {
    if (typeof sel === 'function') {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sel);
      else sel();
      return;
    }
    if (sel === document || sel === window) return new Dom([sel]);
    if (sel && sel.nodeType) return new Dom([sel]);
    if (typeof sel !== 'string') return new Dom([]);
    var root = ctx && ctx.querySelectorAll ? ctx : document;
    // support "select > option" etc.
    try {
      return new Dom(root.querySelectorAll(sel));
    } catch (e) {
      return new Dom([]);
    }
  }
  q.each = function (obj, fn) {
    if (Array.isArray(obj) || (obj && typeof obj.length === 'number')) {
      Array.prototype.forEach.call(obj, function (v, i) { fn.call(v, i, v); });
    } else if (obj) {
      Object.keys(obj).forEach(function (k) { fn.call(obj[k], k, obj[k]); });
    }
  };
  q.inArray = function (val, arr) {
    return Array.prototype.indexOf.call(arr || [], val);
  };

  q.map = function (arr, fn) {
    return Array.prototype.map.call(arr || [], fn);
  };

  function dedupeSelectOptions(scopeSel) {
    document.querySelectorAll(scopeSel).forEach(function (select) {
      var used = {};
      Array.prototype.slice.call(select.options).forEach(function (opt) {
        if (opt.value === 'null') {
          opt.remove();
          return;
        }
        if (used[opt.text]) opt.remove();
        else used[opt.text] = opt.value;
      });
    });
  }

  function observeSelectDedupes() {
    var roots = document.querySelectorAll('.consealer-select, .foundation-select, .pop-up-quiz-con');
    if (!roots.length || !window.MutationObserver) {
      dedupeSelectOptions('.consealer-select select');
      dedupeSelectOptions('.foundation-select select');
      return;
    }
    var timer = null;
    function schedule() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        dedupeSelectOptions('.consealer-select select');
        dedupeSelectOptions('.foundation-select select');
      }, 50);
    }
    roots.forEach(function (root) {
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    });
    schedule();
  }

  function initShadeMatching() {
    if (!document.querySelector('.pop-up-quiz-con')) return;

        q( "#step3" ).click(function() {
        // q('.pop-up-combo-recommendation').delay(5000).fadeIn();
        });
        q( ".cross-inner" ).click(function() {
         q(".pop-up-combo-recommendation").fadeOut();
        });
          q('.recommended-pro').hide();
        //      q('#shade_select').html('<option val="pro-shade">Select Shade</option>');
          function doStuff(data) {

            var unique_mf = [];
            var unique_md = [];
            var unique_yr = [];
           // console.log(data);

            q.each(data, function(key,value) {
        //         console.log('Data- start: '+data[key]+'End');

        //         console.log(key+' : '+value);
        //         console.log(data[key][1]);
               var manufacturer =  data[key][1];
               var model =  data[key][2];
               var year =  data[key][3];

        //           console.log(manu_options);


                var array_unique = data[key][0];
                unique_mf.push(array_unique);

                var array_unique1 = data[key][2];
                unique_md.push(array_unique1);

                var array_unique2 = data[key][3];
                unique_yr.push(array_unique2);


                 });

        //       console.log(unique_mf);

            let uni_manufacture = [...new Set(unique_mf)];


            for (var i = 0; i < uni_manufacture.length; i++) {
              if(uni_manufacture[i]!= null) {
                // console.log(uni_manufacture[i]+'val');
               var manu_options = '<li><input type="radio" name="option-skin" class="skin-opt" value='+ uni_manufacture[i] +'><label>'+uni_manufacture[i]+'</label></li>';

              q('.skin-options').append(manu_options);
        //         console.log(uni_manufacture[i]);
              }
            }

        //       console.log(unique_md);

            let uni_model = [...new Set(unique_md)];


            for (var i = 0; i < uni_model.length; i++) {
               var model_options = '<option value='+uni_model[i]+'>'+uni_model[i]+'</option>';
        //           q('#model_opt').append(model_options);

        //         console.log(model_options[i]);

            }

        //       console.log(unique_yr);

             let uni_year = [...new Set(unique_yr)];


            for (var i = 0; i < uni_year.length; i++) {
               var year_options = '<option value='+uni_year[i]+'>'+uni_year[i]+'</option>';
        //          q('#make_year_opt').append(year_options);
             // console.log(uni_year[i]);

            }




        }

             function doStuffsearch(data) {
              var unique_veh = [];
            var unique_mf = [];
            var unique_md = [];
            var unique_yr = [];
           // console.log(data);

            q.each(data, function(key,value) {
        //         console.log('Data- start: '+data[key]+'End');

        //         console.log(key+' : '+value);
        //         console.log(data[key][1]);
               var manufacturer =  data[key][1];
               var model =  data[key][2];
               var year =  data[key][3];
                var manufacturer_serh =  data[key];
        //           console.log(manu_options);

                var array_unique_veh = data[key][1];
                unique_veh.push(array_unique_veh);

                var array_unique = data[key][1];
                unique_mf.push(array_unique);

                var array_unique1 = data[key][2];
                unique_md.push(array_unique1);

                var array_unique2 = data[key][3];
                unique_yr.push(array_unique2);


                 });



                let uni_unique_veh = [...new Set(unique_veh)];
        var realveh = uni_unique_veh.filter(function (e) {return e != null;});
        //      console.log(realveh);

        //            q('#skin_shade').empty();


               var checkboxes = document.getElementsByName('option-skin');
               for (var checkbox of checkboxes)
               {
                 if (checkbox.checked) {
        //              alert(checkbox.value + ' ');
                   var val_model = checkbox.value.trim();
                   console.log(val_model+'test');
                 }
               }

                var task_names = [];
               data.forEach(function (i) {
                 task_names.push(i);
               });

               console.log(val_model+task_names.length);

            for (var i = 0; i < task_names.length; i++) {
              if(task_names[i].length>1){
        //         console.log(task_names[i]);

               if(q.inArray(val_model, task_names[i]) != -1){
                  console.log(task_names[i][1]);
               var manu_options = '<option value="'+task_names[i][1]+'">'+task_names[i][1]+'</option>';

              q('#skin_shade').append(manu_options);
                 q('.skin-shade').show();
        //         console.log(realveh[i]);
                }

            }
            }
               var first_val = q("#skin_shade option:nth-child(1)").val();
               console.log('First Value: '+first_val);
               q("#skin_shade").val(first_val).change();

        }

             function doStuffsearch2(data) {
              var unique_veh = [];
            var unique_mf = [];
            var unique_md = [];
            var unique_yr = [];
           // console.log(data);

            q.each(data, function(key,value) {
        //         console.log('Data- start: '+data[key]+'End');

        //         console.log(key+' : '+value);
        //         console.log(data[key][1]);
               var manufacturer =  data[key][1];
               var model =  data[key][2];
               var year =  data[key][3];
                var manufacturer_serh =  data[key];
        //           console.log(manu_options);

                var array_unique_veh = data[key][1];
                unique_veh.push(array_unique_veh);

                var array_unique = data[key][1];
                unique_mf.push(array_unique);

                var array_unique1 = data[key][2];
                unique_md.push(array_unique1);

                var array_unique2 = data[key][3];
                unique_yr.push(array_unique2);




                 });

                q('#make_year_opt').html('<option value="default">Select Year</option>');

                  var checkboxes = document.getElementsByName('option-skin');
               for (var checkbox of checkboxes)
               {
                 if (checkbox.checked) {
        //              alert(checkbox.value + ' ');
                   var val_type = checkbox.value.trim();
                   console.log(val_type+': shade');
                 }
               }

        //             var val_type = 'Sensitive';
                  var manufacturer_opt1 = q('#skin_shade').val();

        //              console.log(val_type+manufacturer_opt);
                 var match_array = val_type+manufacturer_opt1;
        //            console.log(match_array);

                  var loc_array =[];
                 loc_array.push(val_type);
                 loc_array.push(manufacturer_opt1);

                 q('#model_opt').empty();

              var val_model = q('#manufacturer_opt').val();
               var task_names = [];
               data.forEach(function (i) {
                 task_names.push(i);
               });

                let checker = (arr, target) => target.every(v => arr.includes(v));


                 const arr1 = loc_array;
                 console.log(arr1);



                  for (var i = 0; i < task_names.length; i++) {

                     var arr2_loc = task_names[i].filter(function (e) {return e != null;});
                   const arr2 = task_names[i];

                    const results = arr2.map(element => {
                      if (typeof element === 'string') {
                        return element.trim();
                      }

                      return element;
                    });

        //           console.log(arr2_loc);
                 const contains = (first, second) => {
                   const indexArray = first.map(el => {
                     return second.indexOf(el);
                   });
                   return indexArray.indexOf(-1) === -1;
                 }


                 var array_checked = contains(arr1, results);
        //               console.log('checked array:- '+array_checked);

                   if (array_checked== true){
        //              console.log(task_names[i]);
                     var model_val = task_names[i][2].replaceAll(' ', '-');
                    var foundation_val = task_names[i][3].replaceAll(' ', '-');
                  var primer_val = task_names[i][4].replaceAll(' ', '-');

                     console.log('Model value:- '+model_val);
                     console.log('concealer value:- '+foundation_val);
                     console.log('Primer value:- '+primer_val);

                     q('.recommended-pro').hide();
                      q('.recommended-pro').removeClass('mail-product');
                     q('.'+model_val).addClass('mail-product');
                     q('.'+model_val).show();

                      q('.'+foundation_val).addClass('mail-product');
                      q('.'+foundation_val).show();

                       q('.'+primer_val).addClass('mail-product');
                      q('.'+primer_val).show();

                     q('#step2').show();
        //                var model_option = '<option value="'+model_val+'">'+model_val+'</option>';
        //                 q("#model_opt").append('<option value="default">Select Model</option>'+model_option);
                   }



                  }






        }


           function doStuffsearchbundle(data) {
              var unique_veh = [];
            var unique_mf = [];
            var unique_md = [];
            var unique_yr = [];
           // console.log(data);

            q.each(data, function(key,value) {
        //         console.log('Data- start: '+data[key]+'End');

        //         console.log(key+' : '+value);
        //         console.log(data[key][1]);
               var manufacturer =  data[key][1];
               var model =  data[key][2];
               var year =  data[key][3];
                var manufacturer_serh =  data[key];
        //           console.log(manu_options);

                var array_unique_veh = data[key][1];
                unique_veh.push(array_unique_veh);

                var array_unique = data[key][1];
                unique_mf.push(array_unique);

                var array_unique1 = data[key][2];
                unique_md.push(array_unique1);

                var array_unique2 = data[key][3];
                unique_yr.push(array_unique2);




                 });

                q('#make_year_opt').html('<option value="default">Select Year</option>');

                  var checkboxes = document.getElementsByName('option-skin');
               for (var checkbox of checkboxes)
               {
                 if (checkbox.checked) {
        //              alert(checkbox.value + ' ');
                   var val_type = checkbox.value.trim();
                   console.log(val_type+': shade');
                 }
               }

        //             var val_type = 'Sensitive';
                  var manufacturer_opt1 = q('#skin_shade').val();

        //              console.log(val_type+manufacturer_opt);
                 var match_array = val_type+manufacturer_opt1;
        //            console.log(match_array);

                  var loc_array =[];
                 loc_array.push(val_type);
                 loc_array.push(manufacturer_opt1);

                 q('#model_opt').empty();

              var val_model = q('#manufacturer_opt').val();
               var task_names = [];
               data.forEach(function (i) {
                 task_names.push(i);
               });

                let checker = (arr, target) => target.every(v => arr.includes(v));


                 const arr1 = loc_array;
                 console.log(arr1);



                  for (var i = 0; i < task_names.length; i++) {

                     var arr2_loc = task_names[i].filter(function (e) {return e != null;});
                   const arr2 = task_names[i];

                    const results = arr2.map(element => {
                      if (typeof element === 'string') {
                        return element.trim();
                      }

                      return element;
                    });

        //           console.log(arr2_loc);
                 const contains = (first, second) => {
                   const indexArray = first.map(el => {
                     return second.indexOf(el);
                   });
                   return indexArray.indexOf(-1) === -1;
                 }


                 var array_checked = contains(arr1, results);
        //               console.log('checked array:- '+array_checked);

                   if (array_checked== true){
        //              console.log(task_names[i]);
                     var model_val = task_names[i][2].replaceAll(' ', '-');
                    var foundation_val = task_names[i][3].replaceAll(' ', '-');
                  var primer_val = task_names[i][4].replaceAll(' ', '-');

                     console.log('Model value:- '+model_val);
                     console.log('concealer value:- '+foundation_val);
                     console.log('Primer value:- '+primer_val);



                     q('.recommended-pro').hide();
                     q('.recommended-pro').removeClass('active-bundle-pro');

                      q('.recommended-pro').removeClass('mail-product');
                     q('.'+model_val).addClass('mail-product');
                     q('.'+model_val).show();

                      q('.'+foundation_val).addClass('mail-product');
                      q('.'+foundation_val).show();

                       q('.'+primer_val).addClass('mail-product');
                      q('.'+primer_val).show();
                       q('.'+primer_val).addClass('active-bundle-pro');

                      if ( model_val == 'eye-light-concealer' && foundation_val == 'decrease-foundation' && primer_val == 'over-dew-primer')
                      {
                      q('.text-combo-name').html("The Over dew Set");
                      q('.the-over-dew-set').show();
                      q('.pop-up-combo-recommendation').delay(5000).fadeIn();
                      }

                      if ( model_val == 'get-even-concealer' && foundation_val == 'get-even-foundation' && primer_val == 'get-even-primer')
                      {
                      q('.text-combo-name').html("The Get Even Set");
                      q('.the-get-even-set').show();
                      q('.pop-up-combo-recommendation').delay(5000).fadeIn();
                      }

                     if ( model_val == 'eye-light-concealer' && foundation_val == 'calm-on-foundation' && primer_val == 'calm-on-primer')
                      {
                      q('.text-combo-name').html("The Calm On Set");
                      q('.the-calm-on-set').show();
                      q('.pop-up-combo-recommendation').delay(5000).fadeIn();
                      }

                       if ( model_val == 'zit-quit-concealer' && foundation_val == 'matte-up-foundation' && primer_val == 'matte-up-balancing-primer')
                      {
                      q('.text-combo-name').html("The Zit Quit Set");
                      q('.the-zit-quit-set').show();
                      q('.pop-up-combo-recommendation').delay(5000).fadeIn();
                      }

                       if ( model_val == 'get-even-concealer' && foundation_val == 'matte-up-foundation' && primer_val == 'matte-up-balancing-primer')
                      {
                      q('.text-combo-name').html("The Matte Up Set");
                      q('.the-matte-up-set').show();
                      q('.pop-up-combo-recommendation').delay(5000).fadeIn();
                      }

                     q('#step2').show();
        //                var model_option = '<option value="'+model_val+'">'+model_val+'</option>';
        //                 q("#model_opt").append('<option value="default">Select Model</option>'+model_option);
                   }



                  }


        }

        //   Step 2 1st brand select options


          function doStuffstep21(data) {

            var unique_mf = [];
            var unique_md = [];
            var unique_yr = [];
           // console.log(data);

            q.each(data, function(key,value) {
        //         console.log('Data- start: '+data[key]+'End');

        //         console.log(key+' : '+value);
        //         console.log(data[key][1]);
               var manufacturer =  data[key][1];
               var model =  data[key][2];
               var year =  data[key][3];

        //           console.log(manu_options);


                var array_unique = data[key][0];
                unique_mf.push(array_unique);

                var array_unique1 = data[key][2];
                unique_md.push(array_unique1);

                var array_unique2 = data[key][3];
                unique_yr.push(array_unique2);


                 });



            let uni_manufacture = [...new Set(unique_mf)];
             // console.log(uni_manufacture);

            for (var i = 0; i < uni_manufacture.length; i++) {

              if(uni_manufacture[i]!= null) {
        <!--            console.log(uni_manufacture[i]); -->
               var manu_options = '<option value="'+uni_manufacture[i]+'">'+uni_manufacture[i]+'</option>';

              q('#brand_select').append(manu_options);
        //         console.log(uni_manufacture[i]);
              }
            }


                q('#step3').on('click', function() {
                  var val_type = q('#brand_select').val();
                  var manufacturer_opt1 = q('#productname_select').val();
                   var model_opt1 = q('#shade_select').val();
        //              var make_year_opt1 = q('#make_year_opt').val();
        //              console.log(manufacturer_opt+model_opt+make_year_opt);
                 var match_array = manufacturer_opt1+','+model_opt1;
        //            console.log(match_array);

                  var loc_array =[];
                 loc_array.push(val_type);
                 loc_array.push(manufacturer_opt1);
                 loc_array.push(model_opt1);
        //            loc_array.push(parseInt(make_year_opt1));
        //            loc_array.push('Small');

                 console.log(loc_array);
                    let checker = (arr, target) => target.every(v => arr.includes(v));


                 const arr1 = loc_array;
                 console.log(arr1);

                  if(arr1[0] == 'default'){
                   alert('Please select options to Search.');

                   }

                 var task_names = data;
                 for (var i = 0; i < task_names.length; i++) {

                 if (q.inArray(arr1, task_names[i]) == 1) {
                   // Neither foo or bar in array

                    var array1234 = q.map(task_names[i], function(value, index){
                       return [value];
                     });
        //              console.log('Araay comp1 : '+task_names[i]);

                     var loc1 =[];
        //              console.log(array123);
                     q.each(array1234, function(index, value){

                         loc1.push(value);

                     });
        //                console.log('Araay comp1 : '+loc1);

                 }

                   const arr2 = task_names[i];
        //             console.log(arr2);
                 const contains = (first, second) => {
                   const indexArray = first.map(el => {
                     return second.indexOf(el);
                   });
                   return indexArray.indexOf(-1) === -1;
                 }


                 var array_checked = contains(arr1, arr2);
                   console.log(array_checked);

                   if (array_checked== true){

                      console.log(contains(arr1, arr2));
                      var skinshade = task_names[i][3];
                     var foundationshade = task_names[i][4];
                     console.log('Skin Shade: '+ skinshade);
                     // console.log('FOundation Shade: '+foundationshade);
                      q('.shade-recommended').html(skinshade);
                     // q('.shade-recommended-fd').html(foundationshade);

                   }





                 }

        //            console.log(checker(array2, array1));  // false


                });


        }
        // End of brand select

        //   Step 2 Select Product Name
            function doStuffsearch22(data) {
              var unique_veh = [];
            var unique_mf = [];
            var unique_md = [];
            var unique_yr = [];
           // console.log(data);

            q.each(data, function(key,value) {
        //         console.log('Data- start: '+data[key]+'End');

        //         console.log(key+' : '+value);
        //         console.log(data[key][1]);
               var manufacturer =  data[key][1];
               var model =  data[key][2];
               var year =  data[key][3];
                var manufacturer_serh =  data[key];
        //           console.log(manu_options);

                var array_unique_veh = data[key][1];
                unique_veh.push(array_unique_veh);

                var array_unique = data[key][1];
                unique_mf.push(array_unique);

                var array_unique1 = data[key][2];
                unique_md.push(array_unique1);

                var array_unique2 = data[key][3];
                unique_yr.push(array_unique2);


                 });



                let uni_unique_veh = [...new Set(unique_veh)];
        var realveh = uni_unique_veh.filter(function (e) {return e != null;});
        //      console.log(realveh);

                 q('#productname_select').empty();


                   var val_model = q('#brand_select').val().trim();
                   console.log(val_model+'test');

                var task_names = [];
               data.forEach(function (i) {
                 task_names.push(i);
               });

               console.log(val_model+task_names.length);

            for (var i = 0; i < task_names.length; i++) {
              if(task_names[i].length>1){
        //         console.log(task_names[i]);

               if(q.inArray(val_model, task_names[i]) != -1){
                  console.log(task_names[i][1]);
               var manu_options = '<option value="'+task_names[i][1]+'">'+task_names[i][1]+'</option>';

              q('#productname_select').append(manu_options);

        //         console.log(realveh[i]);



                }

            }
            }

                var prod_name = q('#productname_select').val().trim();
                   console.log(prod_name+'product name');
               parseData("concealer_shade", doStuffsearch23);
               q('#shade_select').empty();
                q('#shade_select').append('<option val="pro-shade">Select Shade</option>');
        }

        //   Product Shade Select

              function doStuffsearch23(data) {
              var unique_veh = [];
            var unique_mf = [];
            var unique_md = [];
            var unique_yr = [];
           // console.log(data);

            q.each(data, function(key,value) {
        //         console.log('Data- start: '+data[key]+'End');

        //         console.log(key+' : '+value);
        //         console.log(data[key][1]);
               var manufacturer =  data[key][1];
               var model =  data[key][2];
               var year =  data[key][3];
                var manufacturer_serh =  data[key];
        //           console.log(manu_options);

                var array_unique_veh = data[key][1];
                unique_veh.push(array_unique_veh);

                var array_unique = data[key][1];
                unique_mf.push(array_unique);

                var array_unique1 = data[key][2];
                unique_md.push(array_unique1);

                var array_unique2 = data[key][3];
                unique_yr.push(array_unique2);



        //           var val = "Ducati";
        //          var next = manufacturer_serh[(q.inArray(val, manufacturer_serh) + 1) % manufacturer_serh.length];
               //console.log(next);


                 });



                 var val_type = q('#brand_select').val().trim();
                   console.log(val_type+'test');

        //             var val_type = 'Sensitive';
                  var manufacturer_opt1 = q('#productname_select').val();

        //              console.log(val_type+manufacturer_opt);
                 var match_array = val_type+manufacturer_opt1;
        //            console.log(match_array);

                  var loc_array =[];
                 loc_array.push(val_type);
                 loc_array.push(manufacturer_opt1);


              var val_model = q('#manufacturer_opt').val();
               var task_names = [];
               data.forEach(function (i) {
                 task_names.push(i);
               });

                let checker = (arr, target) => target.every(v => arr.includes(v));


                 const arr1 = loc_array;
                 console.log(arr1);

                q('#shade_select').empty();
                q('#shade_select').append('<option val="pro-shade">Select Shade</option>');

                  for (var i = 0; i < task_names.length; i++) {

                     var arr2_loc = task_names[i].filter(function (e) {return e != null;});
                   const arr2 = task_names[i];

                    const results = arr2.map(element => {
                      if (typeof element === 'string') {
                        return element.trim();
                      }

                      return element;
                    });

        //           console.log(arr2_loc);
                 const contains = (first, second) => {
                   const indexArray = first.map(el => {
                     return second.indexOf(el);
                   });
                   return indexArray.indexOf(-1) === -1;
                 }


                 var array_checked = contains(arr1, results);
        //               console.log('checked array:- '+array_checked);

                   if (array_checked== true){
        //              console.log(task_names[i]);
                     var model_val = task_names[i][2].trim();
                     console.log('Model value:- '+model_val);
        //                q('.recommended-pro').hide();
        //                q('.'+model_val).show();
                     var shade_option = '<option value="'+model_val+'">'+model_val+'</option>';
                      q("#shade_select").append(shade_option);
                   }



                  }






        }

        //   End of shade


               q('#filter_srh').on('click', function() {
                 q('.filter-loading').fadeIn();
                 q('.filter-loading').css('display', 'flex');
                 setTimeout(function() {
                   q('.filter-loading').fadeOut();
                 }, 2000);

                  var val_type = q('#vehicle_type').val();
                  var manufacturer_opt1 = q('#manufacturer_opt').val();
                   var model_opt1 = q('#model_opt').val();
                   var make_year_opt1 = q('#make_year_opt').val();
        //              console.log(manufacturer_opt+model_opt+make_year_opt);
                 var match_array = manufacturer_opt1+','+model_opt1+','+make_year_opt1;
        //            console.log(match_array);

                  var loc_array =[];
                 loc_array.push(val_type);
                 loc_array.push(manufacturer_opt1);
                 loc_array.push(model_opt1);
                 loc_array.push(parseInt(make_year_opt1));
        //            loc_array.push('Small');

        //            console.log(loc_array);
                    let checker = (arr, target) => target.every(v => arr.includes(v));


                 const arr1 = loc_array;
                 console.log(arr1);

                 var task_names = [];
                 for (var i = 0; i < data.length; i++) {


                   const arr2 = data[i];
        //             console.log(arr2);
                 const contains = (first, second) => {
                   const indexArray = first.map(el => {
                     return second.indexOf(el);
                   });
                   return indexArray.indexOf(-1) === -1;
                 }


                 var array_checked = contains(arr1, arr2);

                   console.log(array_checked);

                   if (array_checked== true){
                   console.log(data[i]);
                      console.log(contains(arr1, arr2));
                      var checked_strap = data[i][4];

                      if (checked_strap=='Small'){
        //                alert('Small');
                        q('.no_strap_found').fadeOut();
                         q('.small_strap').fadeIn();
                        q('.medium_strap').fadeOut();
                         q('.no_strap').fadeOut();
                     }
                     if (checked_strap=='Medium'){
                        q('.no_strap_found').fadeOut();
                       q('.medium_strap').fadeIn();
                       q('.small_strap').fadeOut();
                         q('.no_strap').fadeOut();
        //                alert('Medium');
                     }
                      if (checked_strap=='?'){
        //                alert('?');
                         q('.no_strap_found').fadeOut();
                          q('.no_strap').fadeIn();
                         q('.medium_strap').fadeOut();
                       q('.small_strap').fadeOut();
                     }

                   }



                 }





                  });





        var __tbQuizSections = null;
        var __tbQuizLoading = null;

        function tbQuizSheetUrl() {
          return (typeof window !== 'undefined' && window.__TB_QUIZ_SHEET__) || '';
        }

        function tbCell(row, key) {
          if (!row) return '';
          var v = row[key];
          if (v === null || v === undefined) return '';
          return typeof v === 'string' ? v.trim() : v;
        }

        function tbBuildQuizSections(rows) {
          var sections = {
            product_match: [],
            concealer_shade: [],
            foundation_shade: []
          };
          (rows || []).forEach(function (row) {
            var section = String(tbCell(row, 'quiz_section') || '').trim();
            if (section === 'product_match') {
              sections.product_match.push([
                tbCell(row, 'skin_type'),
                tbCell(row, 'concern'),
                tbCell(row, 'type_concealer'),
                tbCell(row, 'type_foundation'),
                tbCell(row, 'type_primer')
              ]);
            } else if (section === 'concealer_shade') {
              sections.concealer_shade.push([
                tbCell(row, 'brand'),
                tbCell(row, 'competitor_product'),
                tbCell(row, 'competitor_shade'),
                tbCell(row, 'type_concealer_shade'),
                tbCell(row, 'type_foundation_shade')
              ]);
            } else if (section === 'foundation_shade') {
              sections.foundation_shade.push([
                tbCell(row, 'brand'),
                tbCell(row, 'competitor_product'),
                tbCell(row, 'competitor_shade'),
                tbCell(row, 'type_foundation_shade')
              ]);
            }
          });
          return sections;
        }

        function tbLoadQuizMaster(done) {
          if (__tbQuizSections) {
            done(__tbQuizSections);
            return;
          }
          if (__tbQuizLoading) {
            __tbQuizLoading.push(done);
            return;
          }
          __tbQuizLoading = [done];
          var url = tbQuizSheetUrl();
          if (!url) {
            console.error('[TB Quiz] Missing window.__TB_QUIZ_SHEET__');
            var empty = tbBuildQuizSections([]);
            __tbQuizSections = empty;
            (__tbQuizLoading || []).forEach(function (cb) { cb(empty); });
            __tbQuizLoading = null;
            return;
          }
          Papa.parse(url, {
            download: true,
            header: true,
            skipEmptyLines: true,
            complete: function (results) {
              var sections = tbBuildQuizSections(results.data || []);
              __tbQuizSections = sections;
              (__tbQuizLoading || []).forEach(function (cb) { cb(sections); });
              __tbQuizLoading = null;
            },
            error: function (err) {
              console.error('[TB Quiz] Failed to load master sheet', err);
              var empty = tbBuildQuizSections([]);
              __tbQuizSections = empty;
              (__tbQuizLoading || []).forEach(function (cb) { cb(empty); });
              __tbQuizLoading = null;
            }
          });
        }

        function parseData(section, callBack) {
          tbLoadQuizMaster(function (sections) {
            callBack((sections && sections[section]) || []);
          });
        }

        parseData("product_match", doStuff);



         q(document).on("click",".skin-opt",function() {
        //   alert(this.value);
             parseData("product_match", doStuffsearch);


          });

           q('#skin_shade').on('change', function() {
        //   alert( this.value );
             parseData("product_match", doStuffsearch2);


          });

        //   Step 2 Functions start here

        parseData("concealer_shade", doStuffstep21);

        q('#brand_select').on('change', function() {
          //   alert( this.value );
          parseData("concealer_shade", doStuffsearch22);
        });


         q('#productname_select').on('change', function() {
          //   alert( this.value );
          parseData("concealer_shade", doStuffsearch23);
        });

        q('#shade_select').on('change', function() {
        // q('#step3').show();
        });


        // Foundation Step 2 starts Here

          function doStufffoundation1(data) {
          console.log('Foundation Brands starts here');
            var unique_mf = [];
            var unique_md = [];
            var unique_yr = [];
           console.log(data);

            q.each(data, function(key,value) {
        //         console.log('Data- start: '+data[key]+'End');

        //         console.log(key+' : '+value);
        //         console.log(data[key][1]);
               var manufacturer =  data[key][1];
               var model =  data[key][2];
               var year =  data[key][3];

        //           console.log(manu_options);


                var array_unique = data[key][0];
                unique_mf.push(array_unique);

                var array_unique1 = data[key][2];
                unique_md.push(array_unique1);

                var array_unique2 = data[key][3];
                unique_yr.push(array_unique2);
               });

            let uni_manufacture = [...new Set(unique_mf)];
             console.log(uni_manufacture);

            for (var i = 0; i < uni_manufacture.length; i++) {

              if(uni_manufacture[i]!= null) {
                 console.log(uni_manufacture[i]);
                var foundation_brand = uni_manufacture[i].trim();

               var manu_options1 = '<option value="'+uni_manufacture[i]+'">'+uni_manufacture[i]+'</option>';

              q('#brand_select-fd').append(manu_options1);
        //         console.log(uni_manufacture[i]);
              }
            }

                q('#step3').on('click', function() {
                  var val_type = q('#brand_select-fd').val();
                  var manufacturer_opt1 = q('#productname_select-fd').val();
                   var model_opt1 = q('#shade_select-fd').val();
        //              var make_year_opt1 = q('#make_year_opt').val();
        //              console.log(manufacturer_opt+model_opt+make_year_opt);
                 var match_array = manufacturer_opt1+','+model_opt1;
        //            console.log(match_array);

                  var loc_array =[];
                 loc_array.push(val_type);
                 loc_array.push(manufacturer_opt1);
                 loc_array.push(model_opt1);
        //            loc_array.push(parseInt(make_year_opt1));
              console.log(loc_array);
                    let checker = (arr, target) => target.every(v => arr.includes(v));


                 const arr1 = loc_array;
                 console.log(arr1);

                  if(arr1[0] == 'default'){
                   alert('Please select options to Search.');

                   }

                 var task_names = data;
                 for (var i = 0; i < task_names.length; i++) {

                 if (q.inArray(arr1, task_names[i]) == 1) {
                   // Neither foo or bar in array

                    var array1234 = q.map(task_names[i], function(value, index){
                       return [value];
                     });
        //              console.log('Araay comp1 : '+task_names[i]);

                     var loc1 =[];
        //              console.log(array123);
                     q.each(array1234, function(index, value){

                         loc1.push(value);

                     });
        //                console.log('Araay comp1 : '+loc1);

                 }

                   const arr2 = task_names[i];
        //             console.log(arr2);
                 const contains = (first, second) => {
                   const indexArray = first.map(el => {
                     return second.indexOf(el);
                   });
                   return indexArray.indexOf(-1) === -1;
                 }


                 var array_checked = contains(arr1, arr2);
                   console.log(array_checked);

                   if (array_checked== true){

                      console.log(contains(arr1, arr2));
                      var skinshade = task_names[i][3];
                     var foundationshade = task_names[i][4];
                     // console.log('Skin Shade: '+ skinshade);
                     console.log('FOundation Shade: '+foundationshade);
                      // q('.shade-recommended').html(skinshade);
                     q('.shade-recommended-fd').html(skinshade);

                   }
                 }

                      //            console.log(checker(array2, array1));  // false
         });


        }
        // End of foundation brand select

        //   Step 2 Select Foundation Product Name
            function doStufffoundation2(data) {
              var unique_veh = [];
            var unique_mf = [];
            var unique_md = [];
            var unique_yr = [];
           // console.log(data);

            q.each(data, function(key,value) {
        //         console.log('Data- start: '+data[key]+'End');

        //         console.log(key+' : '+value);
        //         console.log(data[key][1]);
               var manufacturer =  data[key][1];
               var model =  data[key][2];
               var year =  data[key][3];
                var manufacturer_serh =  data[key];
        //           console.log(manu_options);

                var array_unique_veh = data[key][1];
                unique_veh.push(array_unique_veh);

                var array_unique = data[key][1];
                unique_mf.push(array_unique);

                var array_unique1 = data[key][2];
                unique_md.push(array_unique1);

                var array_unique2 = data[key][3];
                unique_yr.push(array_unique2);


                 });



                let uni_unique_veh = [...new Set(unique_veh)];
        var realveh = uni_unique_veh.filter(function (e) {return e != null;});
        //      console.log(realveh);

                 q('#productname_select-fd').empty();


                   var val_model = q('#brand_select-fd').val();
                   console.log(val_model+'test');

                var task_names = [];
               data.forEach(function (i) {
                 task_names.push(i);
               });

               console.log(val_model+task_names.length);

            for (var i = 0; i < task_names.length; i++) {
              if(task_names[i].length>1){
                console.log(task_names[i]);

               if(q.inArray(val_model, task_names[i]) != -1){
                  console.log(task_names[i][1]);

               var manu_options = '<option value="'+task_names[i][1]+'">'+task_names[i][1]+'</option>';

              q('#productname_select-fd').append(manu_options);

        //         console.log(realveh[i]);



                }

            }
            }

                var prod_name = q('#productname_select-fd').val().trim();
                   console.log(prod_name+'product name');
               parseData("foundation_shade", doStufffoundation3);
               q('#shade_select-fd').empty();
                q('#shade_select-fd').append('<option val="pro-shade">Select Foundation Shade</option>');
        }

        //  Foundation Product Shade Select

              function doStufffoundation3(data) {
              var unique_veh = [];
            var unique_mf = [];
            var unique_md = [];
            var unique_yr = [];
           // console.log(data);

            q.each(data, function(key,value) {
        //         console.log('Data- start: '+data[key]+'End');

        //         console.log(key+' : '+value);
        //         console.log(data[key][1]);
               var manufacturer =  data[key][1];
               var model =  data[key][2];
               var year =  data[key][3];
                var manufacturer_serh =  data[key];
        //           console.log(manu_options);

                var array_unique_veh = data[key][1];
                unique_veh.push(array_unique_veh);

                var array_unique = data[key][1];
                unique_mf.push(array_unique);

                var array_unique1 = data[key][2];
                unique_md.push(array_unique1);

                var array_unique2 = data[key][3];
                unique_yr.push(array_unique2);



        //           var val = "Ducati";
        //          var next = manufacturer_serh[(q.inArray(val, manufacturer_serh) + 1) % manufacturer_serh.length];
               //console.log(next);


                 });



                 var val_type = q('#brand_select-fd').val();
                   console.log(val_type+'test');

        //             var val_type = 'Sensitive';
                  var manufacturer_opt1 = q('#productname_select-fd').val();

        //              console.log(val_type+manufacturer_opt);
                 var match_array = val_type+manufacturer_opt1;
        //            console.log(match_array);

                  var loc_array =[];
                 loc_array.push(val_type);
                 loc_array.push(manufacturer_opt1);


              var val_model = q('#manufacturer_opt').val();
               var task_namesf = [];
               data.forEach(function (i) {
                 task_namesf.push(i);
               });

                let checker = (arr, target) => target.every(v => arr.includes(v));


                 const arr1 = loc_array;
                 console.log(arr1);

                q('#shade_select-fd').empty();
                q('#shade_select-fd').append('<option val="pro-shade">Select Shade</option>');

                  for (var i = 0; i < task_namesf.length; i++) {

                     var arr2_loc = task_namesf[i].filter(function (e) {return e != null;});
                   const arr2 = task_namesf[i];

                    const results = arr2.map(element => {
                      if (typeof element === 'string') {
                        return element;
                      }

                      return element;
                    });

                  // console.log(arr1);
                   // console.log(results);

                 const contains = (first, second) => {
                   const indexArray = first.map(el => {
                     return second.indexOf(el);
                   });
                   return indexArray.indexOf(-1) === -1;
                 }


                 var array_checked = contains(arr1, results);
        //               console.log('checked array:- '+array_checked);

                   if (array_checked== true){
        //              console.log(task_namesf[i]);
                     var model_val = task_namesf[i][2].trim();
                     console.log('Model value:- '+model_val);
        //                q('.recommended-pro').hide();
        //                q('.'+model_val).show();
                     var shade_option = '<option value="'+model_val+'">'+model_val+'</option>';
                      q("#shade_select-fd").append(shade_option);
                   }



                  }


        }

        //   Foundation End of shade


         parseData("foundation_shade", doStufffoundation1);

        q('#brand_select-fd').on('change', function() {
          //   alert( this.value );
          parseData("foundation_shade", doStufffoundation2);
        });


         q('#productname_select-fd').on('change', function() {
          //   alert( this.value );
          parseData("foundation_shade", doStufffoundation3);
        });

        q('#shade_select-fd').on('change', function() {
        q('#step3').show();
        });

        /* select option dedupe handled by MutationObserver */

         q("#step2").click(function(){
           q(".Skin-type").fadeOut();
           q(".skin-more-options").fadeIn();
           });

        q("#step3").click(function(){
          q(".skin-more-options").fadeOut();
          q(".recommended-output").fadeIn();
               parseData("product_match", doStuffsearchbundle);
        });

        //   q(".filtered-data .cancel").click(function(){
        //      q("#a").fadeOut();
        //      q("#b").fadeOut();
        //   q('html, body').css({
        //     overflow: 'auto',
        //     height: 'auto'
        // });
        // });



           function sendEmail(recommended_shade,recommended_pro) {
             var resultmail = q('.resultmail').val();
          Email.send({
            Host: "smtp.gmail.com",
            Username : "lornafreetesting@gmail.com",
            Password : "lorna@123",
            To : resultmail,
            From : "lornafreetesting@gmail.com",
            Subject : "Recommended Shade and Product",
            Body : "<html><h2>Recommended Shade: "+recommended_shade+"</h2>\
                    <h3>Recommnded Product: "+recommended_pro+"</h3>\
                    </html>",
          })
          .then(
            message => alert('Mail sent successfully')
          );
        }

        q('#emailresults').on('click', function() {
           var recommended_shade = q('.shade-recommended').html();
        var recommended_pro = q('.mail-product .product-item__title span').html();
          var resultmail = q('.resultmail').val();
          console.log(recommended_shade+' product '+recommended_pro+' Mail: '+resultmail);
        sendEmail(recommended_shade,recommended_pro,resultmail);
        });

    observeSelectDedupes();
  }

  loadPapaParse(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initShadeMatching);
    } else {
      initShadeMatching();
    }
  });
})();
